"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildNRMetaNode = buildNRMetaNode;
exports.hasReplayPrerequisite = hasReplayPrerequisite;
exports.isPreloadAllowed = isPreloadAllowed;
var _nreum = require("../../../common/window/nreum");
var _init = require("../../../common/config/init");
var _featureGates = require("../../utils/feature-gates");
var _runtime = require("../../../common/constants/runtime");
function hasReplayPrerequisite(agentId) {
  return !!(0, _nreum.gosNREUMOriginals)().o.MO &&
  // Session Replay cannot work without Mutation Observer
  (0, _featureGates.canEnableSessionTracking)(agentId) &&
  // requires session tracking to be running (hence "session" replay...)
  (0, _init.getConfigurationValue)(agentId, 'session_trace.enabled') === true; // Session Replay as of now is tightly coupled with Session Trace in the UI
}
function isPreloadAllowed(agentId) {
  return (0, _init.getConfigurationValue)(agentId, 'session_replay.preload') === true && hasReplayPrerequisite(agentId);
}
function buildNRMetaNode(timestamp, timeKeeper) {
  const correctedTimestamp = timeKeeper.correctAbsoluteTimestamp(timestamp);
  return {
    originalTimestamp: timestamp,
    correctedTimestamp,
    timestampDiff: timestamp - correctedTimestamp,
    originTime: _runtime.originTime,
    correctedOriginTime: timeKeeper.correctedOriginTime,
    originTimeDiff: Math.floor(_runtime.originTime - timeKeeper.correctedOriginTime)
  };
}